<template>
  <div class="">
    <a-modal
      v-model:visible="modalConfig.visible"
      :title="modalConfig.title"
      :width="800"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <a-form :model="formState" :rules="rules" ref="formRef">
        <div class="df both-side">
          <!-- <a-form-item label="类型" name="model">
            <a-select
              v-model:value="formState.model"
              placeholder="请选择所属类型"
              style="width: 265px"
              allowClear
              disabled
            >
              <a-select-option value="swan 600">天鹅600</a-select-option>
              <a-select-option value="swan 600P">天鹅600P</a-select-option>
            </a-select>
          </a-form-item> -->
          <a-form-item label="名称" name="name">
            <a-input
              disabled
              v-model:value="formState.name"
              placeholder="请输入名称"
              style="width: 265px"
              allowClear
            ></a-input>
          </a-form-item>

          <a-form-item label="送检人" name="inspectionPersonnel">
            <a-input
              disabled
              v-model:value="formState.inspectionPersonnel"
              placeholder="请输入送检人"
              style="width: 265px"
              allowClear
            ></a-input>
          </a-form-item>
        </div>
        <div class="df both-side">
          <a-form-item label="编码" name="code">
            <a-input
              disabled
              v-model:value="formState.code"
              placeholder="请输入编码"
              style="width: 265px"
              allowClear
            ></a-input>
          </a-form-item>
          <a-form-item label="物料批号" name="materialBatch">
            <a-input
              disabled
              v-model:value="formState.materialBatch"
              placeholder="请输入物料批号"
              style="width: 265px"
              allowClear
            ></a-input>
          </a-form-item>
        </div>
        <div class="df both-side">
          <a-form-item label="SN号" name="snNumber">
            <a-input
              disabled
              v-model:value="formState.snNumber"
              placeholder="请输入SN号"
              style="width: 260px"
              allowClear
            ></a-input>
          </a-form-item>
          <a-form-item label="供应商名称" name="supplier">
            <a-input
              disabled
              v-model:value="formState.supplier"
              placeholder="请输入供应商名称"
              style="width: 265px"
              allowClear
            ></a-input>
          </a-form-item>
        </div>
        <div class="df both-side">
          <a-form-item label="物料类型" name="materialType">
            <a-select
              disabled
              v-model:value="formState.materialType"
              placeholder="请选择物料类型"
              style="width: 235px"
              allowClear
            >
              <a-select-option value="电子物料">电子物料</a-select-option>
              <a-select-option value="结构物料">结构物料</a-select-option>
              <a-select-option value="光学物料">光学物料</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="来料属性" name="incomingMaterialProperties">
            <a-select
              disabled
              v-model:value="formState.incomingMaterialProperties"
              placeholder="请选择来料属性"
              style="width: 265px"
              allowClear
            >
              <a-select-option value="正常来料">正常来料</a-select-option>
              <template v-for="item in 9" :key="item">
                <a-select-option :value="`${item}次换货/返修`"
                  >{{ item }}次换货/返修</a-select-option
                >
              </template>
            </a-select>
          </a-form-item>
        </div>

        <div class="df both-side">
          <a-form-item label="来料数量" name="incomingMaterialNumber">
            <a-input
              disabled
              v-model:value="formState.incomingMaterialNumber"
              placeholder="请输入来料数量"
              style="width: 235px"
              allowClear
            ></a-input>
          </a-form-item>
        </div>

        <div class="df both-side">
          <a-form-item label="送检数量" name="submissionNumber">
            <a-input
              v-model:value="formState.submissionNumber"
              placeholder="请输入送检数量"
              style="width: 235px"
              @change="setPassRate('submissionNumber')"
              allowClear
            ></a-input>
          </a-form-item>
          <a-form-item label="抽检/全检" name="inspectionMethod">
            <a-select
              v-model:value="formState.inspectionMethod"
              placeholder="请选择抽检/全检"
              style="width: 265px"
              allowClear
            >
              <a-select-option value="抽检">抽检</a-select-option>
              <a-select-option value="全检">全检</a-select-option>
            </a-select>
          </a-form-item>
        </div>
        <div class="df both-side">
          <a-form-item label="检验数量" name="inspectionNumber">
            <a-input
              v-model:value="formState.inspectionNumber"
              placeholder="请输入检验数量"
              style="width: 235px"
              @change="setPassRate('inspectionNumber')"
              allowClear
            ></a-input>
          </a-form-item>
          <a-form-item label="合格数量" name="qualifiedNumber">
            <a-input
              v-model:value="formState.qualifiedNumber"
              @change="setPassRate('qualifiedNumber')"
              placeholder="请输入合格数量"
              style="width: 265px"
              allowClear
            ></a-input>
          </a-form-item>
        </div>

        <div class="df both-side">
          <a-form-item label="合格率" name="passRate">
            <a-input
              v-model:value="formState.passRate"
              placeholder="请输入合格率"
              style="width: 255px"
              allowClear
            ></a-input>
          </a-form-item>
          <a-form-item label="检验人" name="inspector">
            <a-input
              v-model:value="formState.inspector"
              placeholder="请输入检验人"
              style="width: 265px"
              allowClear
            ></a-input>
          </a-form-item>
        </div>

        <div class="df both-side">
          <a-form-item label="让步数量" name="concessionNumber">
            <a-input
              v-model:value="formState.concessionNumber"
              placeholder="请输入让步数量"
              style="width: 235px"
              allowClear
            ></a-input>
          </a-form-item>
          <a-form-item label="不能让步数量" name="intransigenceNumber">
            <a-input
              v-model:value="formState.intransigenceNumber"
              placeholder="不能让步数量"
              style="width: 255px"
              allowClear
            ></a-input>
          </a-form-item>
        </div>

        <a-form-item label="让步接收问题">
          <content-dsc-vue
            :question="formState.concessionDesc"
            ref="concessionDescRef"
          ></content-dsc-vue>
        </a-form-item>
        <a-form-item label="不能让步问题描述">
          <content-dsc-vue
            :question="formState.intransigenceDesc"
            ref="intransigenceDescRef"
          ></content-dsc-vue>
        </a-form-item>
        <a-form-item label="备注">
          <content-dsc-vue
            :question="formState.notes"
            ref="notesRef"
          ></content-dsc-vue>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { defineComponent, reactive, ref } from "vue";
import { saveOrUpdateIQC } from "@/request/view/qualityInspection";
import { getlocalDate } from "@/views/productDaily/components/quality/serve/data";
import contentDscVue from "../../components/question.vue";
import { Toast } from "@/utils";
import { useStore } from "vuex";

export default defineComponent({
  components: { contentDscVue },
  setup(props, context) {
    const store = useStore();

    const modalConfig = reactive({
      visible: false,
      title: null,
    });

    const concessionDescRef = ref();
    const intransigenceDescRef = ref();
    const notesRef = ref();

    const formState = reactive({
      id: null,
      // 所属类型
      project: "swan",
      // 名称
      name: null,
      // 编码
      code: null,
      // sn号
      snNumber: null,
      // 供应商
      supplier: null,
      // 合格率
      passRate: null,
      // 抽检/全检
      inspectionMethod: null,
      // 检验人
      inspector: null,
      // 物料类型
      materialType: null,
      // 来料数量
      incomingMaterialNumber: null,
      // 送检数量
      submissionNumber: null,
      // 检验数量
      inspectionNumber: null,
      // 让步接收问题
      concessionDesc: null,
      // 合格数量
      qualifiedNumber: null,
      // 不合格数量
      unqualifiedQuantity: null,
      // 不可让步接收
      intransigenceDesc: null,
      // 物料批号
      materialBatch: null,
      // 来料属性
      incomingMaterialProperties: null,
      // 送检人员
      inspectionPersonnel: null,
      // 日期
      localDate: null,
      // 不能让步数量
      intransigenceNumber: null,
      // 让步接收数量
      concessionNumber: null,
      notes: null,
      userId: null,
      username: null,
    });

    const rules = {
      // model: [
      //   {
      //     required: true,
      //     message: "请选择所属类型",
      //     trigger: "blur",
      //   },
      // ],
      name: [
        {
          required: true,
          message: "请输入名称",
          trigger: "blur",
        },
      ],
      code: [
        {
          required: true,
          message: "请输入编码",
          trigger: "blur",
        },
      ],
      materialBatch: [
        {
          required: true,
          message: "请输入物料批号",
          trigger: "blur",
        },
      ],
      snNumber: [
        {
          required: true,
          message: "请输入SN号",
          trigger: "blur",
        },
      ],
      supplier: [
        {
          required: true,
          message: "请输入供应商名称",
          trigger: "blur",
        },
      ],
      materialType: [
        {
          required: true,
          message: "请选择物料类型",
          trigger: "blur",
        },
      ],
      incomingMaterialProperties: [
        {
          required: true,
          message: "请选择来料属性",
          trigger: "blur",
        },
      ],
      inspectionMethod: [
        {
          required: true,
          message: "请选择抽检/全检",
          trigger: "blur",
        },
      ],
      incomingMaterialNumber: [
        {
          required: true,
          message: "请输入来料数量",
          trigger: "change",
          type: "any",
        },
      ],
      submissionNumber: [
        {
          required: true,
          message: "请输入送检数量",
          trigger: "blur",
          type: "any",
        },
      ],
      inspectionNumber: [
        {
          required: true,
          message: "请输入检验数量",
          trigger: "blur",
          type: "any",
        },
      ],
      qualifiedNumber: [
        {
          required: true,
          message: "请输入合格数量",
          trigger: "blur",
          type: "any",
        },
      ],
      // unqualifiedQuantity: [
      //   {
      //     required: true,
      //     message: "请输入不合格数量",
      //     trigger: "blur",
      //   },
      // ],
      passRate: [
        {
          required: true,
          message: "请输入合格率",
          trigger: "blur",
          type: "any",
        },
      ],
      inspector: [
        {
          required: true,
          message: "请输入检验人",
          trigger: "blur",
        },
      ],
      inspectionPersonnel: [
        {
          required: true,
          message: "请输入送检人",
          trigger: "blur",
        },
      ],
    };

    const formRef = ref();

    const resetForm = () => {
      Object.keys(formState).forEach((key) => {
        formState[key] = null;
      });
      formRef.value.clearValidate();
      modalConfig.visible = false;
      formState.project = "swan";
    };

    const handleCancel = () => {
      resetForm();
    };

    const handleOk = () => {
      formRef.value
        .validate()
        .then(async () => {
          await concessionDescRef.value
            .uploadFile()
            .then((res) => {
              formState.concessionDesc = JSON.stringify(res);
            })
            .catch((err) => {
              console.log(err);
            });

          await intransigenceDescRef.value
            .uploadFile()
            .then((res) => {
              formState.intransigenceDesc = JSON.stringify(res);
            })
            .catch((err) => {
              console.log(err);
            });
          await notesRef.value
            .uploadFile()
            .then((res) => {
              formState.notes = JSON.stringify(res);
            })
            .catch((err) => {
              console.log(err);
            });

          const { id, username } = store.state.user.user;

          if (formState.userId === null && formState.username === null) {
            formState.userId = id;
            formState.username = username;
          }
          saveOrUpdateIQC(formState)
            .then((res) => {
              console.log(res);
              let type = res.code === 200 ? "success" : "warning";
              Toast(type, res.message, 3);
              context.emit("updateTable");
              handleCancel();
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch((err) => {
          console.log(err);
        });
    };

    const setFormData = (data) => {
      Object.keys(formState).forEach((key) => {
        if (
          key === "notes" ||
          key === "intransigenceDesc" ||
          key === "concessionDesc"
        ) {
          formState[key] = JSON.stringify(data[key]);
        } else {
          formState[key] = data[key];
        }
      });
      console.log(formState, "获取到的数据是什么");
    };

    const openModal = (type, data) => {
      modalConfig.visible = true;
      if (type === "addIQC") {
        modalConfig.title = "添加质检记录";
        formState.localDate = getlocalDate();
      } else if (type === "editIQC") {
        modalConfig.title = "编辑质检记录";
        setFormData(data);
      }
    };

    const setPassRate = (type) => {
      if (
        type === "submissionNumber" &&
        formState[type] &&
        formState[type] > formState.incomingMaterialNumber
      ) {
        formState[type] = null;
        Toast("warning", "送检数量不能大于来料数量", 3);
        return;
      }
      if (
        type === "inspectionNumber" &&
        formState[type] &&
        formState[type] > formState.submissionNumber
      ) {
        formState[type] = null;
        Toast("warning", "检验数量不能大于送检数量", 3);
        return;
      }
      if (
        type === "qualifiedNumber" &&
        formState[type] &&
        formState[type] > formState.inspectionNumber
      ) {
        formState[type] = null;
        formState.passRate = null;
        Toast("warning", "合格数量不能大于检验数量", 3);
        return;
      }

      const inspectionNumber = Number(formState.inspectionNumber);
      const qualifiedNumber = Number(formState.qualifiedNumber);
      if (
        formState.inspectionNumber &&
        !isNaN(inspectionNumber) &&
        formState.qualifiedNumber &&
        !isNaN(qualifiedNumber)
      ) {
        formState.passRate = (
          (qualifiedNumber / inspectionNumber) *
          100
        ).toFixed(2);

        if (String(formState.passRate).indexOf(".00") !== -1) {
          formState.passRate = String(formState.passRate).replace(".00", "");
        }
      } else {
        formState.passRate = null;
      }
    };

    return {
      modalConfig,
      formState,
      rules,
      openModal,
      handleCancel,
      handleOk,
      formRef,
      concessionDescRef,
      intransigenceDescRef,
      notesRef,
      setPassRate,
    };
  },
});
</script>

<style lang="less" scoped>
::v-deep .ant-input[disabled] {
  color: #000;
}
::v-deep
  .ant-select-disabled.ant-select:not(.ant-select-customize-input)
  .ant-select-selector {
  color: #000;
}
</style>
